import { render, staticRenderFns } from "./VerifyPaymentsTable.vue?vue&type=template&id=552f4bf4&"
import script from "./VerifyPaymentsTable.vue?vue&type=script&lang=js&"
export * from "./VerifyPaymentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports